import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useParams } from 'react-router';

import { usePixelById } from '@/api/pixel';
import Error404 from '@/components/errors/Error404';
import { PageSpinner } from '@/components/loaders';
import { Page } from '@/components/page';
import { exampleAIQuestions } from '@/constants/exampleAIQuestions';
import SolAPIError from '@/error/SolAPIError';

import PixelEditContent from './PixelEditContent';

const PixelEdit = () => {
  const { pixel: pixelId } = useParams();
  const { pixel, isLoading, error, mutate: mutatePixelById } = usePixelById(pixelId);

  if (error instanceof SolAPIError && error.is404()) {
    return <Error404 title={<Trans>The audience you're looking for does not exist</Trans>} />;
  }

  return (
    <Page title={t`Edit Pixel`} exampleAIQuestions={exampleAIQuestions('pixel')}>
      {isLoading && !pixel ? (
        <PageSpinner />
      ) : pixel ? (
        <PixelEditContent pixel={pixel} mutatePixelById={mutatePixelById} />
      ) : null}
    </Page>
  );
};

export default PixelEdit;
